import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=10f17150&scoped=true&"
import script from "./ErrorComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorComponent.vue?vue&type=script&lang=js&"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=10f17150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f17150",
  null
  
)

export default component.exports